import ApiBaseModel from "@/common/models/ApiBaseModel"
import Helper from "@/common/helper.js"


export default class SubscriptionModel extends ApiBaseModel {        
    title: string = "";    
    description: string = "";
    categoryId: string = "";
    price: number = 0
    tenantId: string = "";
    isActive: boolean = false;    


     
    static from(json: string): SubscriptionModel {
        let model = Object.assign(new SubscriptionModel(), json);            

        return model;
    }
}